import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 20 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.55, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ eyebrow, title, text, light = false, className = "", action }) => (
  <Reveal className={`${className}`}>
    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
      <div className="max-w-3xl">
        {eyebrow && <span className={`eyebrow ${light ? "!text-white/80" : ""}`}>{eyebrow}</span>}
        <h2 className={`mt-3 text-3xl sm:text-4xl lg:text-[40px] font-bold leading-[1.15] ${light ? "!text-white" : ""}`}>{title}</h2>
        {text && <p className={`mt-4 text-base md:text-lg leading-relaxed ${light ? "text-white/80" : "text-[var(--body)]"}`}>{text}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  </Reveal>
);

export const PageIntro = ({ eyebrow, title, accent, text, image, children }) => (
  <section className="relative bg-white overflow-hidden" data-testid="page-intro">
    <div className="container-x py-14 lg:py-20 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
      <div className={image ? "lg:col-span-7" : "lg:col-span-10"}>
        <motion.div initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.55 }}>
          {eyebrow && <span className="eyebrow">{eyebrow}</span>}
          <h1 className="mt-3 text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.1]" data-testid="page-title">
            {title}{accent && <><br /><span className="text-[var(--coral)]">{accent}</span></>}
          </h1>
          {text && <p className="mt-6 text-base md:text-lg text-[var(--body)] leading-relaxed max-w-2xl">{text}</p>}
          {children}
        </motion.div>
      </div>
      {image && (
        <motion.div initial={{ opacity: 0, x: 24 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.6, delay: 0.1 }} className="lg:col-span-5">
          <img src={image} alt={title} className="w-full h-[260px] sm:h-[320px] lg:h-[400px] object-cover corner-tr corner-bl" style={{ borderRadius: "0 80px 0 80px" }} />
        </motion.div>
      )}
    </div>
    <div className="h-4 bg-[var(--blue-tint)]" />
  </section>
);
